module.exports = __webpack_public_path__ + "static/media/02.Aka.Prog.5c00b38c.JPG";